module.exports = __webpack_public_path__ + "src/assets/img/fu-icon.9fbc17ce.png";